import debounce from 'lodash.debounce';

class EventTracker {

  constructor() {
    if (window.Intercom) {
      Intercom('onShow', () => this.track({
        category: 'Button',
        action: 'Open-Intercom',
        label: 'Intercom',
      }));

      Intercom('onHide', () => this.track({
        category: 'Button',
        action: 'Close-Intercom',
        label: 'Intercom',
      }));
    }

    this.trackClickListener = this.trackClickListener.bind(this);
    this.listen = this.listen.bind(this);
    this.debouncedTrack = debounce(this.track, 300);
  }

  track({ category, action, label = '', value = 1 }) {
    if (!category || !action) {
      if (!category && !action) {
        console.warn(`Missing category and action for event tracking.`);
      } else if (!category) {
        console.warn(`Missing category for event tracking.`);
      } else {
        console.warn(`Missing action for event tracking.`);
      }

      return;
    }

    try {
      // recent versions of Chrome give us CORS errors if we send an application/json content type
      if (navigator) {
        const blob = new Blob([JSON.stringify({
          category,
          action,
          label
        })], { type : 'text/plain; charset=ascii' });
        navigator.sendBeacon('/api/user/event', blob);
      }
    } catch (e) {
      console.error('error', e);
    };

    // Check if google analytics object exists
    if (window.ga) {
      const {
        userId,
        dimension1,
        dimension2,
        dimension3,
        dimension4,
      } = window.googleAnalyticsDimensions || {};

      ga('send', 'event', {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value,
        userId,
        dimension1,
        dimension2,
        dimension3,
        dimension4,
      });
    }

    if (window.Intercom) {
      Intercom('trackEvent', category, { action, label, value });
    }
  }

  trackClickListener({ currentTarget }) {
    this.track({
      category: currentTarget.getAttribute('data-track'),
      action: currentTarget.getAttribute('data-track-action'),
      label: currentTarget.getAttribute('data-track-label'),
      value: currentTarget.getAttribute('data-track-value'),
    });
  }

  listen(root) {
    $(root)
      .find('[data-track]')
      .off('click.track')
      .on('click.track', this.trackClickListener);
  }
}

export default new EventTracker();



// WEBPACK FOOTER //
// ./shared/lib/event-tracking.js